import { render, staticRenderFns } from "./jiadonglv.vue?vue&type=template&id=35a34912&"
import script from "./jiadonglv.vue?vue&type=script&lang=js&"
export * from "./jiadonglv.vue?vue&type=script&lang=js&"
import style0 from "./jiadonglv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports